import { IWykrojnikParams } from "./IWykrojnikParams";
import { WykrojnikParams } from "./WykrojnikParams";

export class WykrojnikParamsGen {
    x:number = 0
    y:number = 0
    static wp:IWykrojnikParams = WykrojnikParams.get_test_params();


    public static async calc(xx:number, yy:number, ksztalt:string,szerokosci:number[], zeby:number[], banda_min:number,is_folia:number, podklad:string, grubosc_podkladu:number) {

      const x=this.round3(xx);
      const y=this.round3(yy);
      
      this.wp.szerokosci = szerokosci;
      this.wp.zeby = zeby;
      this.wp.banda_min = banda_min;
      this.wp.is_folia= is_folia;
      this.wp.grubosc_podkladu=grubosc_podkladu;
      this.wp.podklad=podklad;

      const x1_min:number    = this.get_x1_min(ksztalt, is_folia);
      const y1_min:number    = this.get_y1_min(ksztalt, is_folia);

      this.wp.min =  await this.init_min(x, y, x1_min, y1_min, banda_min );
      this.wp.max =  await this.init_max(x, y, x1_min, y1_min, banda_min );

      this.wp.szukaj_iml = 0;
      this.wp.szukaj_papier =0;
      this.wp.szukaj_folia=0;
      this.wp.ignore_podklad=0;
  

      
      return this.wp;

    }

    static round3(xx:number) {
      let x:number=0
      if (!xx) xx=0;
      if (xx) x=Number.parseFloat(parseFloat(xx.toString()).toFixed(3));
      return x;
    }

    static round0(xx:number) {
      let x:number=0
      if (!xx) xx=0;
      if (xx) x=Number.parseFloat(parseFloat(xx.toString()).toFixed(0));
      return x;
    }

    private static get_x1_min(ksztalt:string, is_folia:number) {

        let x1 = 0.0;
        if (ksztalt != "N") { // regularna
          if (is_folia) x1 = 2.9;
          else          x1 = 3.1;
        }
        else {
          if (is_folia) x1 = 4.1;
          else          x1 = 4.3;
        }
        return x1;
    }

    private static get_y1_min(ksztalt:string, is_folia:number) {

      let y1 = 0.0;
      if (ksztalt != "N") { // regularna
        if (is_folia) y1 = 2.8;
        else 		  y1 = 3.0;
      }
      else {
        if (is_folia) y1 = 3.5;
        else 		  y1 = 4.2;
      }
      return y1;
    }


    private static init_min(x:number, y:number, x1_min:number, y1_min:number, banda_min:number) {
      
      const min={
        x:x,
        x1:x1_min,
        y:y,
        y1:y1_min,
        banda:banda_min,          
        ux:1.0,
        uy:1.0,
        szerokosc:125.0,
        zeby:0.0,
        R:0.0,
        }
        return min;
  }

  private static init_max(x:number, y:number, x1_min:number, y1_min:number, banda_min:number) {

    const szer_max=430;
    const banda_max=szer_max;

    const zeby_max=192;
    const dlg_max=zeby_max*3.175;
    const uy_max=this.round0((dlg_max/(y+y1_min))+1);

    // const tst=(szer_max - banda_min + x1_min)/(x+x1_min)
    const ux_max=this.round0(   (szer_max - banda_min + x1_min)/(x+x1_min)   )+1;

    const x1_max=szer_max;
    const y1_max=dlg_max;

    const max={
    x:x,
    x1:x1_max,
    y:y,
    y1:y1_max,
    banda:banda_max,          
    ux:ux_max,
    uy:uy_max,
    szerokosc:szer_max,
    zeby:zeby_max,
    R:0.0,
    }
    return max;
  }



}
